import '../../styles/antd-theme.less'
import 'video-react/dist/video-react.css'

import { Col, Layout, Row } from 'antd'
import { darken } from 'polished'
import * as React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import { GlobalStyle } from '../../styles/globalStyle'
import { theme } from '../../styles/theme'
import { SetHead } from './SetHead'
import SiteHeader from './SiteHeader'

const { Footer, Content } = Layout

const StyledFooter = styled(Footer)`
  ${({ theme, darktheme }) => `
    text-align: center;
    background-color: ${darken(0.05, theme['theme-color'])};
    background-color: ${
      darktheme === 'true'
        ? theme['dark-background']
        : darken(0.05, theme['theme-color'])
    }
    a{
      text-align: center;
      font-size: 1.25em;
      color: ${
        darktheme === 'true' ? theme['dark-theme-color'] : theme[theme['title']]
      } !important;
    }
`};
`

const StyledContent = styled(Content)`
  flex: 1;
`

const StyledBody = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`

const SiteLayout = ({
  children,
  path,
  title,
  description,
  darktheme = false,
  imageName = 'logo.png',
}: {
  children: React.ReactNode
  path: string
  title?: string
  description?: string
  darktheme?: boolean
  imageName?: string
}) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <StyledBody>
          <GlobalStyle />
          <SetHead
            path={path}
            title={title}
            description={description}
            imageName={imageName}
          />
          <SiteHeader darktheme={darktheme} />
          <StyledContent>{children}</StyledContent>
          <StyledFooter darktheme={darktheme.toString()}>
            <Row>
              <Col sm={{ span: 7, offset: 1 }} xs={{ offset: 1, span: 22 }}>
                <a href={'https://www.codemochi.com/tos/'}>Terms of Service</a>
              </Col>
              <Col sm={{ span: 7, offset: 1 }} xs={{ offset: 1, span: 22 }}>
                <a href={'https://www.codemochi.com/privacy-policy/'}>
                  Privacy Policy
                </a>
              </Col>
              <Col sm={{ span: 7, offset: 1 }} xs={{ offset: 1, span: 22 }}>
                <a href={'https://www.codemochi.com/cookie-policy/'}>
                  Cookie Policy
                </a>
              </Col>
            </Row>
          </StyledFooter>
        </StyledBody>
      </ThemeProvider>
    </>
  )
}

export default SiteLayout
